export default __webpack_public_path__ + "images/2feac99cf65405078987df19c0c3a9fa.svg";